import * as ACTIONS from '../constants/patientEnrollForm';

const initialState = {
  loading: false,
  error: false,
  success: {},
  step: 0,
  patientInformation: {
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    dob: '',
    email: '',
    mobilePhoneNumber: '',
    gender: '',

    pharmacyInsurance: {
      pbmName: '',
      memberId: '',
      bin: '',
      pcn: '',
      group: '',
    },

    prescriber: {
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
    },

    drugAnswers: {
      hasMedicare: null,
      hasMedicaid: null,
      isGovermentPaid: null,
      isAge18: null,
      hasMedicalAcknowledge: null,
      isAgree: null,
      hasAnyOtherGovermentInsurance: null,
      termAndCondAccepted: null,
      hasPermissionOptIn: null,
      hasMarketingOptIn: null,
    },
  },
};

function patientEnrollForm (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.PATIENT_ENROLL.CHANGE_STEP:
    case ACTIONS.SUBMIT_PATIENT_ENROLL_FORM.INIT:
    case ACTIONS.SUBMIT_PATIENT_ENROLL_FORM.ERROR:
    case ACTIONS.SUBMIT_PATIENT_ENROLL_FORM.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.PATIENT_ENROLL.UPDATE_PATIENT_INFO:
      return {
        ...state,
        patientInformation: {
          ...state.patientInformation,
          ...action.payload,
        },
      };
    case ACTIONS.PATIENT_ENROLL.CLEAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}

export default patientEnrollForm;
